import React from "react";
import { MARQUEE_ITEMS } from "../../lib/catalog";

export default function Marquee() {
    const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
    return (
        <div
            className="bg-[#F5F5F4] border-y border-stone-200 py-4 overflow-hidden"
            data-testid="marquee-ticker"
        >
            <div className="marquee font-mono text-[13px] text-stone-600 uppercase tracking-[0.15em]">
                <div className="marquee__track">
                    {items.map((it, i) => (
                        <span key={i} className="flex items-center gap-3">
                            <span className="w-1.5 h-1.5 bg-[#4D7C0F] rounded-full inline-block"></span>
                            {it}
                        </span>
                    ))}
                </div>
                <div className="marquee__track" aria-hidden="true">
                    {items.map((it, i) => (
                        <span key={`d-${i}`} className="flex items-center gap-3">
                            <span className="w-1.5 h-1.5 bg-[#4D7C0F] rounded-full inline-block"></span>
                            {it}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
}
